import { createFileRoute } from "@tanstack/react-router";
import NewContentPage from "@/pages/NewContentPage";
import { homeHead } from "@/lib/publicLocale";

export const Route = createFileRoute("/fr/")({
  head: () => homeHead("fr"),
  component: NewContentPage,
});